import RestrictionImage from "../../img/Restrict.png";
import { Navigate } from "react-router";
import CopyRight from "./CopyRight";

const Restriction = () => {
  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 overflow-auto p-4">
        <img
          src={RestrictionImage}
          alt="403"
          className="mb-3"
          style={{ height: "40vh" }}
        />

        <div className="tnc">
          <h1 className="copyright text-center mb-3 bold">We are Sorry...</h1>

          <div className="text-center copyright mb-5">
            <div>The page your'are trying to access has restricted access.</div>

            <div>Please refer to your system administrator</div>
          </div>

          <button
            type="submit"
            className="mb-2 w-100 btn signinbutton"
            onClick={() => Navigate(-1)}
          >
            Go Back
          </button>

          <CopyRight />
        </div>
      </div>
    </>
  );
};

export default Restriction;
